import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { View } from '@shared/components/View';
import { LightColorTheme } from '@shared/styles';
import { User } from '@shared/types/user';
import { Image } from '../Image';
import { InitialsAvatar } from '../InitialsAvatar';
import classNames from './UserImage.module.css';

export interface UserImageProps {
  user?: User;
  size?: 'large' | 'normal' | 'small' | 'tiny';
  /** Without `className` or `style`, the image fills its parent. */
  className?: ClassValue;
  style?: CSSProperties;
}

export function UserImage({ user, size = 'normal', className, style }: UserImageProps) {
  const fill = isNil(className) && isNil(style);

  if (!user) {
    return (
      <View center fill={fill} className={[classNames.placeholder, className]} style={style} />
    );
  }

  if (!user.imageUrl || user.imageUrl.includes('imgur.com')) {
    return (
      <LightColorTheme>
        <InitialsAvatar
          name={user.fullName}
          id={user.id}
          size={size}
          className={className}
          style={style}
        />
      </LightColorTheme>
    );
  }

  return <Image fill={fill} className={className} style={style} source={{ uri: user.imageUrl }} />;
}
